import type { TFunction } from 'i18next';

export const createDateOptions = (t: TFunction) =>
  ['180', '365', '730', 'max'].map((option) => ({
    label:
      option !== 'max'
        ? t('components:date_filter.last_n_days', { days: option })
        : t('components:date_filter.max_period'),
    value: String(option),
  }));

export const createPreventiveOptions = (t: TFunction) => [
  {
    label: t(`monitoring:tables.filters.preventive.non-preventive`),
    value: 'Z2',
  },
  {
    label: t(`monitoring:tables.filters.preventive.preventive`),
    value: 'Z1',
  },
  {
    label: t(`monitoring:tables.filters.preventive.all`),
    value: 'all',
  },
];
